interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <div className="flex items-center justify-center gap-2 mt-10">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        aria-label="上一页"
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-base w-4 h-4 flex items-center justify-center"></i>
      </button>

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? "page" : undefined}
          className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
            item === page
              ? "bg-primary-600 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          }`}
        >
          {item}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        aria-label="下一页"
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-base w-4 h-4 flex items-center justify-center"></i>
      </button>
    </div>
  );
}